import { html } from 'wirejs-dom/v2';
import type { AuthenticationState } from 'wirejs-resources';

const TITLE = 'Jon Wire';
const SUBTITLE = 'A Software Engineer exploring the world with code.';
const MENU_ID = 'account-menu';
const DISCLAIMER = () => html`<p>
	This content on this site is largely exploratory. I'm sure some of it is embarrassingly wrong <span class='muted'>(or just plain embarrassing)</span>. Please <a href='mailto:jon@jonwire.com'>contact me</a> if you'd like to request a correction, making a suggestion, hear me talk at you, or work with me in some capacity.
	<br /><br />
	Some of my articles may include links to things you can buy. These links will normally be affiliate/associate links. When you use those links, it helps keep coffee in me so I can write more. If I publish any interactive and <b>expensive to operate</b> content, I will paywall that content. This allows you to confidently use the heck out of the site without worrying that my kids will go hungry.
	<br /><br />
	© ${new Date().getFullYear()} Jon Wire.
</p>`;


export async function Main(slots: {
	/**
	 * Replaces the default prefix in the final page title.
	 */
	siteTitle?:
		| string
		| ((state: AuthenticationState) => string);

	/**
	 * Appears on the page under the site title.
	 * 
	 * Set to empty-string explicitly to omit the default.
	 */
	siteSubTitle?:
		| string
		| ((state: AuthenticationState) => string);

	/**
	 * The page title. Appears below the site title and subtitle when given.
	 */
	title?:
		| string
		| ((state: AuthenticationState) => string);

	/**
	 * The main content for the page.
	 */
	content:
		| HTMLElement
		| ((state: AuthenticationState) => HTMLElement);

	/**
	 * Text description to use in page metadata.
	 */
	description?:
		| string;

	/**
	 * Appears in the top of the footer.
	 */
	disclaimer?: 
		| string
		| HTMLElement
		| ((state: AuthenticationState) => string | HTMLElement);
}) {
	const pageTitle = slots.title ? html`
		<h2 style='font-variant: small-caps;'>
			${slots.title}
		</h2>
	` : '';

	const metaDescription = slots.description
		? `<meta
			name="description"
			content="${slots.description.replaceAll('"', '&quot;')}">`
		: '';

	const browserBarTitle = [
		slots.title,
		slots.siteTitle || TITLE,
		slots.siteSubTitle || SUBTITLE,
	].filter(Boolean).slice(0, 3).join(' - ');

	return html`
		<!doctype html>
		<html id='root'>
			<head>
				<meta name="viewport" content="width=device-width, initial-scale=1" />
				${metaDescription}
				<title>${browserBarTitle}</title>
				<link rel='icon' type='image/svg+xml' href='/static/images/logo.svg' />
				<link rel='stylesheet' type='text/css' href='/static/default.css' />
				<link rel="stylesheet" href="/static/github-theme.css" />
			</head>
			<body>
				<div class='main'>
					<header>
						<img class='logo' src='/static/images/logo.svg' />
						<div>
							<h1><a href='/'>${slots.siteTitle || TITLE}</a></h1>
							<div class='tagline'>${slots.siteSubTitle ?? SUBTITLE}</div>
							<div class='nav'>
								<a href='/'>Home</a>
								| <a href='/about.html'>About</a>
							</div>
						</div>
					</header>
					${pageTitle}
					<div id='content'>${slots.content}</div>
					<footer>
						${slots.disclaimer ?? DISCLAIMER()}
					</footer>
				</div>
			</body>
		</html>
	`;
}

// TODO: fix wirejs requiring ... whatever it is here that it requires that breaks the type!
// hydrate(MENU_ID, Account as any);

export function onload() {
	console.log('onload from template.')
}